import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { ErpAnlegenProps } from '../registry'
import { besprechungKonfig } from './api'

/**
 * AP-49 3., 4.1 — **Besprechungsart im Anlegedialog.** Projekt + Art bilden die Serie; die Laufnummer
 * schlägt der Server vor, Teilnehmer und offene Aufgaben schreibt er aus der letzten freigegebenen
 * Besprechung fort. Der Titel („Baubesprechung Nr. 7") entsteht dabei — das Titelfeld entfällt.
 */
export function BesprechungAnlegen({ onWert }: ErpAnlegenProps) {
  const { t } = useTranslation()
  const [arten, setArten] = useState<string[]>([])
  const [art, setArt] = useState<string | null>(null)

  useEffect(() => {
    besprechungKonfig()
      .then((k) => {
        setArten(k.arten)
        setArt(k.arten[0] ?? null)
      })
      .catch(() => setArten([]))
  }, [])

  useEffect(() => {
    onWert({ content: art ? { art } : null, titelAutomatisch: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [art])

  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{t('siteDocs.meeting.type')}</p>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label={t('siteDocs.meeting.type')}>
        {arten.map((a) => (
          <button key={a} type="button" role="radio" aria-checked={art === a} onClick={() => setArt(a)} className={cn('h-9 rounded-md border px-3 text-sm', art === a && 'border-primary bg-primary/10')}>
            {a}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">{t('siteDocs.meeting.createHint')}</p>
    </div>
  )
}
